// TODO: Remove once old Dashboard code is removed.
module.exports = {
  oldRespDashboardCompnentEvents: {
    OldRespDashboard: {
      code: 'DASHBOARD',
      events: {
        ReferClick: {
          description: 'Triggers when user clicks refer a friend CTA on old dashboard',
          eventHub: {
            code: 'REFER_CLICK',
            action: 'Old_Dashboard_Clicked Refer a friend'
          }
        }
      }
    }
  }
};
